import { SET_PROFILE_DATA } from './constants';

const initialState = {
  values: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROFILE_DATA:
      return {
        ...state,
        values: action.payload
      };
    default:
      return state;
  }
};

export default reducer;